import { BoolMetaDataInterface, MessageContainerInterface, ModifiedSubscriberInterface } from '@nts/std/interfaces';
import { ZoomPropertyViewModel } from './zoom-property-view-model';

export class BoolZoomPropertyViewModel extends ZoomPropertyViewModel<boolean>  {
  
  constructor(propertyMetaData: BoolMetaDataInterface, modifiedSubscriber: ModifiedSubscriberInterface) {
    super(propertyMetaData, modifiedSubscriber);
    if (this.value == null) {
      this.resetValue();
    }
  }

  override removeError(item: MessageContainerInterface) {
    throw new Error("Method not implemented.");
  }

  override resetValue() {
    this.typedValue = false;
  }

  setValue(propertyValue: Object) {
    if (propertyValue == null) {
      this.resetValue();
    } else {
      // TODO
      // let ic = propertyValue as IConvertible;
      // if (ic == null)
      // {
      //     throw new ArgumentException();
      // }

      // this.typedValue = ic.ToString(CultureInfo.InvariantCulture);
      this.typedValue = <boolean>propertyValue;
    }
  }
}
